module.exports = __webpack_public_path__ + "img/telephone-icon.91c5bf31.png";